<div fxLayout="row">
    <div fxFlex="0 0 400px" fxLayout="column" [formGroup]="form">
        <h4 matDialogTitle>Create New Tax Rate</h4>
        <p>This process will create a new tax rate on Xero to correspond with your HireLogic tax rates.</p>
        <mat-form-field>
            <input matInput placeholder="Tax Rate Name" formControlName="name">
        </mat-form-field>

        <p>Tax Rate: {{taxRate.value * 100}}%</p>

        <p class="text-red-600" *ngIf="xeroError">An error occurred while trying to create your tax rate.
            The response from Xero was: {{xeroError}}</p>

        <div matDialogActions fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
            <button mat-raised-button (click)="dialogRef.close()" type="button">Cancel</button>
            <button mat-raised-button [disabled]="!form?.valid" color="primary"
                    (click)="submit()"
                    id="save-account" type="submit">Save Tax Rate
            </button>
        </div>
    </div>
</div>